import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ProjectsGrid from "./components/ProjectsGrid";
import StrategicPartners from "@/pages/home/components/StrategicPartners";
import CTASection from "@/pages/home/components/CTASection";
import ContactSection from "@/pages/home/components/ContactSection";

export default function Projelerimiz() {
  return (
    <main className="bg-[#F8FAFC]">
      <Navbar />
      <ProjectsGrid />
      <StrategicPartners />
      <CTASection />
      <ContactSection />
      <Footer />
    </main>
  );
}
